(function () {
  const snowContainer = document.createElement("div");
  snowContainer.id = "snow-container";
  document.body.appendChild(snowContainer);

  const snowflakeCount = window.innerWidth < 768 ? 30 : 60;

  function createSnowflake() {
    const snowflake = document.createElement("span");
    snowflake.className = "snowflake";
    snowflake.innerHTML = "❄";

    const size = Math.random() * 10 + 8;
    const startX = Math.random() * window.innerWidth;
    const duration = Math.random() * 10 + 8;
    const delay = Math.random() * 5;

    snowflake.style.left = startX + "px";
    snowflake.style.fontSize = size + "px";
    snowflake.style.animationDuration = duration + "s";
    snowflake.style.animationDelay = delay + "s";

    snowContainer.appendChild(snowflake);

    setTimeout(() => {
      snowflake.remove();
    }, (duration + delay) * 1000);
  }

  for (let i = 0; i < snowflakeCount; i++) {
    setTimeout(createSnowflake, i * 300);
  }

  setInterval(createSnowflake, 500);
})();
